module.exports = __webpack_public_path__ + "media/title_pc_2.e3ca5622.mp4";